import dayjs from 'dayjs';

export interface Step1Errors {
    [key: string]: string;
}

export const validateStep1 = (formData: any): Step1Errors => {
    const errors: Step1Errors = {};

    const isEmpty = (v: any) => v === undefined || v === null || v === '';

    if (!formData.calleRuta || formData.calleRuta.trim().length < 3) {
        errors.calleRuta = 'Debe tener al menos 3 caracteres';
    }

    const lat = parseFloat(formData.latitud);
    const lng = parseFloat(formData.longitud);

    const numeroKmVal = formData.numeroKm?.toString().trim();
    const isNumeroKmEmptyOrZero = isEmpty(numeroKmVal) || numeroKmVal === '0';

    const hasLatLng =
        !isEmpty(formData.latitud) && !isEmpty(formData.longitud) && !isNaN(lat) && !isNaN(lng);

    if (isNumeroKmEmptyOrZero) {
        if (!hasLatLng) {
            errors.latitud = 'Debe indicar la latitud si no especifica número KM';
            errors.longitud = 'Debe indicar la longitud si no especifica número KM';
        } else {
            if (lat < -90 || lat > 90) {
                errors.latitud = 'Debe estar entre -90 y 90';
            }
            if (lng < -180 || lng > 180) {
                errors.longitud = 'Debe estar entre -180 y 180';
            }
        }
    } else {
        if (!/^[\w\s\-\/]{1,10}$/.test(numeroKmVal)) {
            errors.numeroKm = 'Debe ser un valor alfanumérico breve';
        }
    }

    if (isEmpty(formData.departamento)) {
        errors.departamento = 'Campo obligatorio';
    }

    if (!formData.idProvincia) {
        errors.idProvincia = 'Debe seleccionar una provincia';
    }
    if (!formData.idLocalidad) {
        errors.idLocalidad = 'Debe seleccionar una localidad';
    }

    if (!/^\d{4,8}$/.test(formData.codigoPostal)) {
        errors.codigoPostal = 'Debe tener entre 4 y 8 dígitos';
    }

    const superficie = Number(formData.superficieM2);
    if (isNaN(superficie) || superficie < 0) {
        errors.superficieM2 = 'Debe ser un número mayor o igual a 0';
    }

    const plantas = Number(formData.cantidadPlantas);
    if (isNaN(plantas) || plantas < 0) {
        errors.cantidadPlantas = 'Debe ser un número mayor o igual a 0';
    }

    if (!formData.descripcionObra || formData.descripcionObra.trim().length < 10) {
        errors.descripcionObra = 'Debe tener al menos 10 caracteres';
    }

    const fechaInicio = formData.fechaInicio ? dayjs(formData.fechaInicio) : null;
    const fechaFin = formData.fechaFin ? dayjs(formData.fechaFin) : null;

    if (!fechaInicio || !fechaInicio.isValid()) {
        errors.fechaInicioObra = 'Debe indicar la fecha de inicio de obra';
    }

    if (!fechaFin || !fechaFin.isValid()) {
        errors.fechaFinObra = 'Debe indicar la fecha de finalización de obra';
    }

    if (fechaInicio && fechaFin && fechaInicio.isAfter(fechaFin)) {
        errors.fechaFinObra = 'Debe ser mayor o igual a la fecha de inicio';
    }

    const idTipoResolucion = Number(formData.idTipoResolucion);
    const requiereFechaPrograma = ![1, 2].includes(idTipoResolucion);

    if (requiereFechaPrograma) {
        const fechaPresentacionPrograma = formData.fechaPresentacionPrograma
            ? dayjs(formData.fechaPresentacionPrograma)
            : null;

        if (!fechaPresentacionPrograma || !fechaPresentacionPrograma.isValid()) {
            errors.fechaPresentacionPrograma =
                'Debe indicar una fecha válida para la presentación del programa';
        }
    }

    return errors;
};

export const validateField = (name: string, formData: any): string | undefined => {
    const allErrors = validateStep1(formData);
    return allErrors[name];
};
